import { Component, OnInit } from '@angular/core';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
import { IBreadcrumbConfig } from '../../core/interfaces/breadcrumb-config';

@Component({
  selector: 'aig-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss'],
  imports: [ ContactFormComponent, BreadcrumbComponent ]
})
export class ContactPageComponent implements OnInit {

  public bdConfig: IBreadcrumbConfig = { link : "/", title : "Seguro de Ciberseguridad" };

  constructor() { }

  ngOnInit() {
  }

}
